exports.IDS = {
  // IMG_URL: "http://127.0.0.1:7778",
  // IMG_URL: "http://192.168.16.23:7778",
  // IMG_URL: "https://jeetomaxnode.profcymadev.com:1140",
  IMG_URL: "https://node.jeetomax.com",

  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  BLOCK: "BLOCKED",
  UNBLOCK: "UNBLOCKED",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },

  Admin: 1,
  Roles: {
    Admin: 1,
    SuperSuperMaster: 2,
    SuperMaster: 3,
    Master: 4,
    Client: 5,
    Employee: 6,
  },
};
